class DropList extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("drop", this.__dzDropHandler.bind(this));
    this.addEventListener("dragover", this.__dzDragover.bind(this));
    this.addEventListener("dragleave", this.__dzDragLeave.bind(this));
    this.setAttribute("dropzone", "move");

    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.innerHTML = `
    <style>
      :host {
        display: block;
        border: 0.2rem dotted #f5d7cc;
        min-height: 8rem;
      }
      :host(:hover) {
        border-color: #ffd4c5;
      }
      :host([active]) {
        border-color: #FA91AE;
      }
    </style>
    <slot></slot>
    `;
    this.__isEmpty();
  }
  
  __isEmpty() {
    document.querySelectorAll('drop-list').forEach((dropList) => {
      if (dropList.querySelectorAll('drop-list-item').length > 0) {
        dropList.removeAttribute("is-empty");
      } else {
        dropList.setAttribute("is-empty", "true");
      }
    });
  }

  /**
   * Functionality for the list container once and item has been dropped
   * @param {object} event drop
   */
  __dzDropHandler(event) {
    event.preventDefault();
    this.appendChild(this.__draggingElement);
    this.__draggingElement = null;
    this.removeAttribute("active");
    this.__isEmpty();
  }

  __dzDragLeave() {
    this.__draggingElement = null;
    this.removeAttribute("active");
    this.__isEmpty();
  }

  /**
   * Functionality for the list container once we are hover on the list
   * @param {object} event drop
   */
  __dzDragover(event) {
    event.preventDefault();
    this.setAttribute("active", "");
    let found;

    if (!this.__draggingElement) {
      // find what we're looking for in the composed path that isn't a slot
      found = event.composedPath().find((i) => {
        if (i.nodeType === 1 && i.nodeName !== "SLOT") {
          return i;
        }
      });

      if (found) {
        // find where we are deep in the change
        const theLowestShadowRoot = found.getRootNode();
        this.__draggingElement = theLowestShadowRoot.querySelector(
          "[dragging]"
        );
      } else {
        this.__draggingElement = document.querySelector("[dragging]");
      }
    }
  }
}
customElements.define('drop-list', DropList);


class DropListItem extends HTMLElement {
  constructor() {
    super();

    this.cart = this.closest('.js-cart-boxes');
    this.cartDrawer = this.closest('cart-drawer-items');

    this.addEventListener("drag", this.__drag.bind(this));
    
    this.addEventListener("dragstart", this.__dragStart.bind(this));
    this.addEventListener("dragend", this.__dragEnd.bind(this));
    this.addEventListener("drop", this.__dragEnd.bind(this));
    this.addEventListener("dragover", this.__dragOver.bind(this));
    this.addEventListener("dragleave", this.__dragLeave.bind(this));
    
    this.indissociable = this.getAttribute('indissociable');
    
    this.setAttribute("draggable", "true");
    this.mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    this.cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");

    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.innerHTML = `
    <style>
      :host {
        display: block;
        padding: 0.5rem;
        margin: 0.25rem;
      }
      :host([dragging]) {
        background-color: #FFEDE6;
      }
    </style>
    <slot></slot>
    `;
  }

  __dragStart(event) {
    //event.dataTransfer.setData("text/html", event.target.closest('drop-list-item').innerHTML);
    if (this.indissociable) {
      Toast(window.notificationStrings.indissociable, 'notice')
      event.preventDefault();
      return;
    }
    this.setAttribute("dragging", "");
  }
  
  __drag(event) {
    if (!event.target.hasAttribute('dragging') || !this.cartDrawer) {
      return;
    }

    const container = this.cartDrawer || this.cart || document.documentElement || document.body;
    const containerRect = container.getBoundingClientRect();
    const containerTop = containerRect.top;
    const containerHeight = containerRect.height;
    const containerBottom = containerTop + containerHeight;
    const scrollHeight = container.scrollHeight;
    const scrollPos = container.scrollTop;
    const maxScroll = scrollHeight - containerHeight;
    
    const mouseY =  event.clientY;
    const threshold = this.cartDrawer ? 100 : 150;
    const speed = 10;

    this.stopY = true;
    
    if (mouseY < threshold) {
      this.stopY = false;
      this.scroll(-1);
      
    } else if ((mouseY > containerBottom - threshold) && !this.verticalMaxed()) { 
      this.stopY = false;
      this.scroll(1) ;
    }
    
  }
  
  scroll(direction) {
    this.cartDrawer.scroll(0, (this.cartDrawer.scrollTop + direction)); 
     
    if (!this.stopY) {
      setTimeout(() => { 
        this.scroll(direction) 
      }, 20);
    }
  }
  
  verticalMaxed(){ 
    return (this.cartDrawer.innerHeight + this.cartDrawer.scrollY) >= this.cartDrawer.offsetHeight
  }

  __dragEnd(event) {
    this.__save(event);
    
    this.removeAttribute("over");
    this.removeAttribute("dragging");
    this.stopY = true;
  }

  __dragOver() {
    if (this.hasAttribute("dragging")) {
      this.removeAttribute("over");
    } else {
      this.setAttribute("over", "");
    }
  }

  __dragLeave() {
    this.removeAttribute("over");
  }
  
  __save(event) {
    const dropListItem = event.target.closest('drop-list-item');
    const currentRef = dropListItem.getAttribute('ref');
    const parentRef = dropListItem.parentElement.getAttribute('ref');
    
    if (currentRef === parentRef || dropListItem.hasAttribute("saving")) return;
    
    dropListItem.setAttribute("saving", "true")
    
    const line = dropListItem.dataset.index
    const indexOfItemByValue = parseInt(line)-1
    const currentCartItem = Shopify.cartProperties.items[indexOfItemByValue];

    if (indexOfItemByValue !== -1) {
      dropListItem.setAttribute('ref', parentRef)
      this.mainCartItems.classList.add('cart__items--disabled');
      this.cartItems
        .querySelectorAll(`.loading-overlay[data-index="${line}"]`)
        .forEach((overlay) => overlay.classList.remove('hidden'));
      this.cartItems.lineItemStatusElement.setAttribute('aria-hidden', false);
      
      let productData = {}
      productData['id'] = currentCartItem.key;
      productData['quantity'] = currentCartItem.quantity;
      productData['properties'] = {};
      Object.entries(currentCartItem.properties).forEach(([key, value]) => {
        if (Shopify.cartPropertiesKeys.indexOf(key) !== -1) {
          productData['properties'][`_${key}`] = value;
        } else {
          productData['properties'][key] = value;
        }
      });
      if (parentRef) {
        productData['properties']['_ref'] = parentRef;
      } else if (productData['properties'].hasOwnProperty('_ref') ){
        delete productData['properties']['_ref'];
      }
      
      productData['sections'] = this.getSectionsToRender().map((section) => section.section)
      productData['sections_url'] = window.location.pathname;

      const body = JSON.stringify(productData);
      fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          Shopify.setCartProperties(parsedState);
          this.getSectionsToRender().forEach((section => {
            if (section.id && section.selector 
                && document.getElementById(section.id) 
                && document.getElementById(section.id).querySelector(section.selector)
                && parsedState.sections[section.section]
               ) {
              const sectionElement = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            } else {
              const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            }
            //const sectionElement = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            //if (parsedState.sections[section.section]) {
              //sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            //}
          }));
          dropListItem.removeAttribute("saving");
        })
        .finally((e) => {
            this.mainCartItems.classList.remove('cart__items--disabled');
            this.cartItems
              .querySelectorAll(`.loading-overlay[data-index="${line}"]:not(.hidden)`)
              .forEach((overlay) => overlay.classList.add('hidden'));
            this.cartItems.disableLoading();
        });
    }
  }

  getSectionsToRender() {
    let sectionsToRender = [];
    
    if (document.getElementById('main-cart-items')) {
      sectionsToRender.push({
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-cart-boxes",
      });
    }
    
    if (document.querySelector('cart-drawer')) {
      sectionsToRender.push({
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      });
    }
    
    return sectionsToRender;
  }
  
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define('drop-list-item', DropListItem);

